import { useContext } from 'react'

import { MODALS_ID } from '../../constants'

import { ModalContext } from '../../provider/ModalProvider'

import { Button } from '../button'
import { Modal } from '../modal'

interface AlertProps {
  content: any
  footer?: string
}

export function Alert({ content, footer }: AlertProps) {
  const { closeModal } = useContext(ModalContext)

  const close = () => closeModal(MODALS_ID.ALERT)

  return (
    <Modal id={MODALS_ID.ALERT}>
      {content}
      <Modal.Footer>
        <Button block={true} onClick={close}>
          {footer || '확인'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export type { AlertProps }
